import { Company } from 'src/constants/types';

export interface ShortUrlConfig {
  baseUrl: string;
  customDomain?: string;
}

export interface CompanyWithShortUrl extends Company {
  shortUrl?: string;
}

export const buildShortUrl = (code: string, config: ShortUrlConfig): string => {
  if (config.customDomain) {
    return `${config.customDomain}/${code}`;
  }
  return `${config.baseUrl}/${code}`;
};

export const getShortUrlConfig = (company?: CompanyWithShortUrl): ShortUrlConfig => {
  const currentDomain = window.location.origin;

  // Default to current domain
  const baseUrl = currentDomain;

  // If company has a custom shortUrl domain, use it
  const customDomain = company?.shortUrl || undefined;

  return {
    baseUrl,
    customDomain,
  };
};

export const validateShortUrlDomain = (domain: string): boolean => {
  try {
    // Basic validation - should be a valid URL
    const url = new URL(domain.startsWith('http') ? domain : `https://${domain}`);
    return url.hostname.length > 0;
  } catch {
    return false;
  }
};

/**
 * Formats a short URL code into a complete URL
 * @param code The short URL code
 * @param company Optional company for custom domain
 * @returns Complete short URL
 */
export const formatShortUrl = (code: string, company?: CompanyWithShortUrl): string => {
  const config = getShortUrlConfig(company);
  return buildShortUrl(code, config);
};
